var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFE4AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 15C8.4375 14.8757 8.48689 14.7564 8.57479 14.6685C8.6627 14.5806 8.78193 14.5312 8.90625 14.5312H19.9622L17.0119 11.5819C16.9239 11.4939 16.8744 11.3745 16.8744 11.25C16.8744 11.1255 16.9239 11.0061 17.0119 10.9181C17.0999 10.8301 17.2193 10.7807 17.3438 10.7807C17.4682 10.7807 17.5876 10.8301 17.6756 10.9181L21.4256 14.6681C21.4693 14.7117 21.5039 14.7634 21.5275 14.8203C21.5512 14.8773 21.5633 14.9383 21.5633 15C21.5633 15.0617 21.5512 15.1227 21.5275 15.1797C21.5039 15.2366 21.4693 15.2883 21.4256 15.3319L17.6756 19.0819C17.5876 19.1699 17.4682 19.2193 17.3438 19.2193C17.2193 19.2193 17.0999 19.1699 17.0119 19.0819C16.9239 18.9939 16.8744 18.8745 16.8744 18.75C16.8744 18.6255 16.9239 18.5061 17.0119 18.4181L19.9622 15.4687H8.90625C8.78193 15.4687 8.6627 15.4194 8.57479 15.3315C8.48689 15.2435 8.4375 15.1243 8.4375 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c95ad0fdb2a3d953e196994cc5e20ede.svg";
export { ForwardRef as ReactComponent };